import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../../../service/user.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router'; import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
``

@Component({
  selector: 'app-resetPassword',
  templateUrl: './resetPassword.component.html',
  styleUrls: ['./resetPassword.component.css']
})
export class ResetPasswordComponent implements OnInit {

  public completeRegisterForm: FormGroup;
  token: string
  data: Object;
  loading = false
  errPass: string
  errConfPass: string
  errDontMatch: string
  step = 1

  //translations
  err1: string
  err2: string
  err3: string
  err4: string


  constructor(
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    public translate: TranslateService,
    private _snackBar: MatSnackBar
  ) {
    this.getTranslatedStrings()
  }

  getTranslatedStrings() {
    this.translate.get(['REG_ERR4', 'RP_ERR1', 'RP_ERR2', 'RP_ERR3'])
      .subscribe(translations => {
        this.err1 = translations['REG_ERR4']
        this.err2 = translations['RP_ERR1']
        this.err3 = translations['RP_ERR2']
        this.err4 = translations['RP_ERR3']
      })
  }

  ngOnInit() {
    this.completeRegisterForm = this.builder.group({

      password: [null, [Validators.required]],
      confirmPassword: [null, [Validators.required]]
    });

    this.route.params.subscribe(paramsId => {
      this.token = paramsId['token']
    });


  }

  confirm() {

    if (this.completeRegisterForm.controls.password.value === null)
      this.errPass = this.err1
    if (this.completeRegisterForm.controls.confirmPassword.value === null)
      this.errConfPass = this.err2
    if (this.completeRegisterForm.controls.password.value !== null &&
      this.completeRegisterForm.controls.confirmPassword.value !== null &&
      this.completeRegisterForm.controls.confirmPassword.value !== this.completeRegisterForm.controls.password.value)
      this.errDontMatch = this.err3

    if (!this.errPass && !this.errConfPass && !this.errDontMatch) {
      //NO ERRORS
      this.data = {
        password: this.completeRegisterForm.controls.password.value,
        token: this.token
      }

      this.userService.resetPassword(this.data)
        .then(resp => {

          if (resp.status == 200) {
            this.step++
            setTimeout(() => {
              this.router.navigate(['/logon'])
            }, 5000)
          }
        })
        .catch(e => {
          this._snackBar.open(this.err4, "", {
            duration: 5000,
          });
        })
    }
  }

  clearErr(field: string) {
    switch (field) {
      case 'pass':
        this.errDontMatch = ''
        this.errPass = ''
        break
      case 'confPass':
        this.errDontMatch = ''
        this.errConfPass = ''
        break
      default:
        throw new Error('Unknown field name')
    }
  }

  focusOutCheck(field: string) {
    switch (field) {
      case 'pass':
        if (this.completeRegisterForm.controls.password.value === null)
          this.errPass = this.err1
        else if (this.completeRegisterForm.controls.confirmPassword.value !== null &&
          this.completeRegisterForm.controls.confirmPassword.value !== this.completeRegisterForm.controls.password.value)
          this.errDontMatch = this.err3
        break
      case 'confPass':
        if (this.completeRegisterForm.controls.confirmPassword.value === null)
          this.errConfPass = this.err2
        else if (this.completeRegisterForm.controls.password.value !== null &&
          this.completeRegisterForm.controls.confirmPassword.value !== this.completeRegisterForm.controls.password.value)
          this.errDontMatch = this.err3
        break
      default:
        throw new Error('Unknown field name')
    }
  }

}

